import "../terms.css";

const Privacy = () => {
  return (
    <div>
      <h1
        style={{
          fontSize: "32px",
          lineHeight: "32px",
          color: "#fff",
          backgroundClip: "unset",
          animation: "none",
          WebkitBackgroundClip: "unset",
          WebkitTextFillColor: "unset",
          background: "transparent",
          marginBottom: "24px",
          marginTop: "24px",
          fontWeight: 700,
        }}
      >
        Privacy Policy for DecoHouse
      </h1>

      <p>
        <strong>Effective Date:</strong> 10 October, 2025 <br />
        <strong>Last Updated:</strong> 10 October, 2025
      </p>

      <p>
        <strong>DecoHouse</strong> (the "App") is developed and operated by{" "}
        <strong>MB Kozidev</strong> ("we," "our," "us"). This Privacy Policy
        explains how we collect, use, store, and protect your personal data when
        you use DecoHouse.
      </p>

      <h2>1. Contact Information</h2>
      <p>
        If you have questions or concerns about this policy, please contact us
        at:
        <br />
        <strong>Email:</strong> support@kozidevtech.com
        <br />
        <strong>Address:</strong> Laisves pr. 60-1107, LT-05120, Vilnius,
        Lithuania
      </p>

      <h2>2. Scope</h2>
      <p>
        This Privacy Policy applies to all users of DecoHouse worldwide. By
        using our app, you acknowledge that your information may be processed in
        accordance with this policy.
      </p>

      <h2>3. Information We Collect</h2>
      <p>
        We collect only the minimum information necessary to operate the app:
      </p>

      <h3>• Personal Information</h3>
      <ul>
        <li>
          <strong>Email address</strong> (collected during account registration
          to authenticate and maintain your account).
        </li>
      </ul>

      <h3>• Usage Data</h3>
      <p>
        Through <strong>AppsFlyer</strong> (analytics and attribution service),
        we collect anonymized usage data{" "}
        <em>only after consent is provided in GDPR countries</em>. This may
        include events such as app installs and interactions that help us
        improve functionality and user experience.
      </p>

      <h3>• Support Communications</h3>
      <p>
        If you contact us by email, we collect your email address and any
        information you provide in your message.
      </p>

      <h3>• Media Access</h3>
      <p>
        To provide image generation functionality, DecoHouse needs access to
        your device’s photo gallery. Your selected photos are:
      </p>
      <ul>
        <li>
          Temporarily transmitted to Google Services for AI image generation,
          and
        </li>
        <li>
          Not stored on our servers once processing is complete. Generated
          images are saved locally on your device.
        </li>
      </ul>

      <h2>4. How We Use the Information</h2>
      <p>We use collected data to:</p>
      <ul>
        <li>
          <strong>Provide core app functionality</strong> (account management,
          image generation)
        </li>
        <li>
          <strong>Authenticate users</strong> (via email login)
        </li>
        <li>
          <strong>Analyze app performance</strong> using AppsFlyer (after
          consent where required)
        </li>
        <li>
          <strong>Identify and fix errors</strong> via Sentry (error tracking
          tool)
        </li>
        <li>
          <strong>Respond to support inquiries</strong>
        </li>
      </ul>
      <p>
        We do <strong>not</strong> use data for profiling or automated
        decision-making.
      </p>

      <h2>5. In-App Purchases</h2>
      <p>
        DecoHouse offers in-app purchases for credits used to generate images.
        All payments are processed securely through <strong>Google Play</strong>{" "}
        or the <strong>Apple App Store</strong>.
      </p>
      <p>
        We do not collect or store your payment card information. Only the
        information necessary to fulfill your purchase (such as your account ID
        and transaction confirmation) is shared with the store.
      </p>

      <p>
        For questions about refunds or billing, please follow the store’s
        respective policies:
      </p>
      <ul>
        <li>
          <a
            href="https://support.google.com/googleplay/answer/2479637"
            target="_blank"
          >
            Google Play Refund Policy
          </a>
        </li>
        <li>
          <a href="https://support.apple.com/en-us/HT204084" target="_blank">
            Apple App Store Refund Policy
          </a>
        </li>
      </ul>

      <h2>6. Data Sharing and Third Parties</h2>
      <p>
        We only share data with trusted service providers necessary to operate
        DecoHouse:
      </p>

      <table>
        <thead>
          <tr>
            <th>Service</th>
            <th>Purpose</th>
            <th>Role</th>
            <th>Data Shared</th>
            <th>Privacy Policy</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Sashido</strong>
            </td>
            <td>Backend hosting &amp; database</td>
            <td>Processor</td>
            <td>User account data</td>
            <td>
              <a
                href="https://www.sashido.io/en/policies/#privacy-policy"
                target="_blank"
              >
                Sashido Privacy Policy
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Google Services</strong>
            </td>
            <td>AI image processing</td>
            <td>Processor / Independent controller</td>
            <td>Temporarily transmitted images</td>
            <td>
              <a href="https://policies.google.com/privacy" target="_blank">
                Google Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://ai.google.dev/gemini-api/docs/usage-policies"
                target="_blank"
              >
                Usage Policies
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>AppsFlyer</strong>
            </td>
            <td>Analytics &amp; attribution</td>
            <td>Processor</td>
            <td>Usage data</td>
            <td>
              <a
                href="https://www.appsflyer.com/legal/privacy-policy/"
                target="_blank"
              >
                AppsFlyer Privacy Policy
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Sentry</strong>
            </td>
            <td>Error monitoring</td>
            <td>Processor</td>
            <td>App performance/error data</td>
            <td>
              <a href="https://sentry.io/privacy/" target="_blank">
                Sentry Privacy Policy
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        We <strong>do not sell, rent, or trade</strong> personal data.
      </p>

      <h2>7. Data Storage and Security</h2>
      <ul>
        <li>
          Data is stored on <strong>Sashido’s US-based servers</strong>.
        </li>
        <li>
          We apply <strong>industry-standard security measures</strong>,
          including encryption in transit (HTTPS/TLS), restricted access
          controls, and secure password hashing.
        </li>
        <li>
          Only authorized personnel can access user data for legitimate
          operational needs.
        </li>
      </ul>

      <h2>8. Data Retention</h2>

      <table>
        <thead>
          <tr>
            <th>Data Type</th>
            <th>Retention Period</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>User account data</td>
            <td>
              As long as the account is active (inactive if no images generated
              in 12 months)
            </td>
          </tr>
          <tr>
            <td>Support communications</td>
            <td>12 months after last correspondence</td>
          </tr>
          <tr>
            <td>Payment/transaction data</td>
            <td>7 years (for accounting/legal compliance)</td>
          </tr>
          <tr>
            <td>Analytics data</td>
            <td>As per AppsFlyer’s retention policy</td>
          </tr>
          <tr>
            <td>Backups/logs</td>
            <td>90 days</td>
          </tr>
        </tbody>
      </table>

      <p>When data is no longer needed, it is deleted or anonymized.</p>

      <h2>9. International Data Transfers</h2>
      <p>
        We may transfer your data to servers located in the United States. We
        ensure such transfers are protected through{" "}
        <strong>adequate safeguards</strong>, such as standard contractual
        clauses (SCCs) approved by the European Commission.
      </p>

      <h2>10. Your Rights (GDPR and Global Privacy Laws)</h2>
      <p>Depending on your jurisdiction, you may have the right to:</p>
      <ul>
        <li>Access, correct, or delete your personal data</li>
        <li>Object to or restrict processing</li>
        <li>Withdraw consent (where applicable)</li>
        <li>Request a copy of your data</li>
      </ul>
      <p>
        To exercise these rights, please contact us at{" "}
        <a href="mailto:support@kozidevtech.com">support@kozidevtech.com</a>.
      </p>

      <h2>11. Children’s Privacy</h2>
      <p>
        DecoHouse is not directed to or intended for children under 13 (or under
        16 in the EU). We do not knowingly collect personal information from
        minors.
      </p>

      <h2>12. Legal Bases for Processing (GDPR)</h2>
      <ul>
        <li>
          <strong>Consent:</strong> For analytics and attribution (AppsFlyer).
        </li>
        <li>
          <strong>Legitimate Interest:</strong> For creating user accounts,
          processing user images, and ensuring app functionality.
        </li>
        <li>
          <strong>Legal Obligation:</strong> For retaining payment records.
        </li>
      </ul>

      <h2>13. Updates to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Users will be
        notified of changes <strong>via email or in-app pop-up</strong>.
      </p>

      <h2>GDPR</h2>

      <h3>Data Controller</h3>
      <p>
        <strong>MB Kozidev</strong>
        <br />
        Contact:{" "}
        <a href="mailto:support@kozidevtech.com">support@kozidevtech.com</a>
      </p>

      <h3>Data Processors</h3>
      <ul>
        <li>Sashido (data hosting)</li>
        <li>AppsFlyer (analytics, with consent)</li>
        <li>Google Services (AI image generation)</li>
        <li>Sentry (error tracking)</li>
      </ul>

      <h3>Data Protection Rights</h3>
      <ul>
        <li>Request access to your data (Article 15)</li>
        <li>Request correction (Article 16)</li>
        <li>Request deletion (Article 17)</li>
        <li>Restrict processing (Article 18)</li>
        <li>Request data portability (Article 20)</li>
        <li>Object to processing (Article 21)</li>
      </ul>

      <p>
        If you believe your rights have been violated, you may lodge a complaint
        with your local Data Protection Authority (DPA).
      </p>
    </div>
  );
};

export default Privacy;
